import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';

@Injectable()
export class AiAssistantService {
  constructor(private http: CsHttpClientService) {}

  askQuery(query: string): Observable<any> {
    return this.http.writeText<any>('api/query/ask', { query });
  }

  submitFeedback(data : {responseId: number, feedback: boolean}): Observable<any> {
    return this.http.writeText<any>('api/query/feedback', { data });
  }
}
